import { render } from "./upButton_simple.vue?vue&type=template&id=f0a8509a&scoped=true"
import script from "./upButton_simple.vue?vue&type=script&lang=js"
export * from "./upButton_simple.vue?vue&type=script&lang=js"

import "./upButton_simple.vue?vue&type=style&index=0&id=f0a8509a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a8509a"]])

export default __exports__